// test1057
(1057 && 0);
